import { c as _c } from "react/compiler-runtime";
interface OphthalmologyIconProps {
  size?: number;
  className?: string;
}
const OphthalmologyIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M13.8585 12.3218C12.8809 12.3218 12.0866 13.1161 12.0866 14.0937M23.8883 14.0937C23.8883 14.0937 20.5048 20.0203 13.8585 20.0203C7.21218 20.0203 3.82861 14.0937 3.82861 14.0937C3.82861 14.0937 7.21218 8.16699 13.8585 8.16699C20.5048 8.16699 23.8883 14.0937 23.8883 14.0937ZM13.8585 10.1765C11.6928 10.1765 9.93451 11.9348 9.93451 14.1005C9.93451 16.2661 11.6928 18.0244 13.8585 18.0244C16.0241 18.0244 17.7824 16.2661 17.7824 14.1005C17.7824 11.9348 16.0241 10.1765 13.8585 10.1765Z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] !== t3 || $[4] !== t5) {
    t7 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}</svg>;
    $[3] = t3;
    $[4] = t5;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  return t7;
};
export default OphthalmologyIcon;